import { Divider } from '@mui/material';
import { GoogleBrandIcon } from '../google-brand-icon/google-brand-icon';
import { Button } from '../../../../primitives/button';

type GoogleLoginSectionProps = {
  isLoading: boolean;
  disabled?: boolean;
  onSignIn: () => void;
  label?: string;
};

export const GoogleLoginSection = ({
  isLoading,
  disabled,
  onSignIn,
  label = 'Sign in with Google',
}: GoogleLoginSectionProps) => (
  <>
    <Divider sx={{ alignSelf: 'stretch' }}>or</Divider>
    <Button
      type="button"
      variant="secondary"
      fullWidth
      size="large"
      startIcon={<GoogleBrandIcon />}
      disabled={disabled || isLoading}
      loadingPosition="start"
      loading={isLoading}
      onClick={onSignIn}
      sx={{
        minHeight: 40,
        borderRadius: 1,
        borderColor: '#747775',
        backgroundColor: '#FFFFFF',
        color: '#1F1F1F',
        fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(','),
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.25rem',
        letterSpacing: '0.015625rem',
        textTransform: 'none',
        boxShadow: 'none',
        '& .MuiButton-startIcon': {
          marginLeft: 0,
          marginRight: 1.5,
        },
        '&:hover': {
          borderColor: '#D2E3FC',
          backgroundColor: '#F8FAFF',
          boxShadow: 'none',
        },
        '&:active': {
          backgroundColor: '#ECF3FE',
          borderColor: '#D2E3FC',
        },
        '&.Mui-disabled': {
          borderColor: '#DADCE0',
          backgroundColor: '#FFFFFF',
          color: '#1F1F1F61',
        },
      }}
    >
      {label}
    </Button>
  </>
);
